import { call, put, select, race, delay } from "redux-saga/effects";
import { actions as mobileInsuranceActions } from "@/reducers/mobile-insurance-reducer";
import { getMobileInsuranceLegals as getMobileInsuranceLegalsPromise } from "@/sagas/saga-temp/get-mobile-insurance-legals";

const contextStore = (state) => state.main.context;

export function* getMobileInsuranceLegals(args) {
  try {
    const { data } = args;
    const context = yield select(contextStore);
    const { response, timeout } = yield race({
      response: call(getMobileInsuranceLegalsPromise, {
        data,
        context,
      }),
      timeout: delay(3000),
    });

    if (timeout) {
      console.log("Timeout 3s en getMobileInsuranceLegals");
      yield put(mobileInsuranceActions.getMobileInsuranceError());
      return null;
    }
    // const response = mockGetItem;

    yield put(mobileInsuranceActions.getMobileInsuranceLegalsSuccess(response));
  } catch (error) {
    yield put(mobileInsuranceActions.getMobileInsuranceError());
    console.log("getItem Error", error);
  }
}
